import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  url: string;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  public breadcrumbs$: Observable<BreadcrumbItem[]> = this.breadcrumbsSubject.asObservable();

  constructor() { }


  getCurrentBreadcrumbs(): BreadcrumbItem[] {
    return this.breadcrumbsSubject.value;
  }


  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
    this.breadcrumbsSubject.next(breadcrumbs);
  }


  clearBreadcrumbs() {
    this.breadcrumbsSubject.next([]);
  }


  addBreadcrumb(breadcrumb: BreadcrumbItem) {
    const current = this.breadcrumbsSubject.value;
    this.breadcrumbsSubject.next([...current, breadcrumb]);
  }


  updateLastBreadcrumb(breadcrumb: BreadcrumbItem) {
    const current = this.breadcrumbsSubject.value;
    if (current.length > 0) {
      current[current.length - 1] = breadcrumb;
      this.breadcrumbsSubject.next([...current]);
    }
  }
}
